import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e46368f")

_pushScopeId("data-v-1e46368f")
const _hoisted_1 = { class: "text-16px font-semibold text-black-lp-400 mb-1 font-montserrat" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center w-full font-montserrat" }
const _hoisted_3 = { class: "text-24px font-bold text-red-lp-100 mb-6 underline" }
const _hoisted_4 = { class: "w-full border border-gray-lp-400 rounded-lg flex flex-row py-2 text-center" }
const _hoisted_5 = { class: "flex-1 flex flex-col items-center justify-center border-r border-gray-lp-400 px-2" }
const _hoisted_6 = { class: "text-12px text-gray-lp-300 mb-1" }
const _hoisted_7 = { class: "text-14px font-semibold text-black-lp-300 leading-tight" }
const _hoisted_8 = { class: "text-12px text-gray-lp-300 mt-0.5" }
const _hoisted_9 = { class: "flex-1 flex flex-col items-center justify-center border-r border-gray-lp-400 px-2" }
const _hoisted_10 = { class: "text-12px text-gray-lp-300 mb-1" }
const _hoisted_11 = { class: "text-14px font-semibold text-black-lp-300" }
const _hoisted_12 = { class: "flex-1 flex flex-col items-center justify-center px-2" }
const _hoisted_13 = { class: "text-12px text-gray-lp-300 mb-1" }
const _hoisted_14 = { class: "text-14px font-semibold text-black-lp-300" }
const _hoisted_15 = { class: "flex flex-row justify-between w-full gap-4 font-montserrat" }
const _hoisted_16 = { class: "flex flex-col w-48 py-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_CustomOverlay = _resolveComponent("CustomOverlay")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        customWidth: '742px',
        image: "badge-success",
        onClose: _ctx.onClose
      }, {
        title: _withId(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.titleText), 1)
        ]),
        custom: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.invoiceData.invoiceNo), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("tagihan.form.billedTo")), 1),
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.invoiceData.bookedBy), 1),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.maskingPhoneNumber), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("tagihan.form.totalStt")), 1),
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.invoiceData.totalStt) + " STT ", 1)
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.amountLabel), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.formattedAmount), 1)
              ])
            ])
          ])
        ]),
        "custom-button": _withId(() => [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('tagihan.modal.close'),
              outline: true,
              color: "red-lp-100",
              textColor: "red-lp-100",
              onClick: _ctx.onClose,
              customClass: "px-12 py-2.5"
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_CustomOverlay, {
              ref: "customOverlay",
              overlayWidth: "12rem",
              arrowPosition: "right-24",
              isContentHavePadding: false
            }, {
              trigger: _withId(() => [
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('tagihan.modal.downloadInvoice'),
                  icon: 'chevron-down-white',
                  iconRight: true,
                  color: "red-lp-100",
                  textColor: "white",
                  customClass: "px-4 py-2.5"
                }, null, 8, ["title"])
              ]),
              default: _withId(() => [
                _createVNode("div", _hoisted_16, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.downloadOptions, (option, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "px-4 py-3 hover:bg-red-lp-50 hover:text-red-lp-100 cursor-pointer text-left text-14px text-black-lp-400 border-b border-gray-lp-100 last:border-0",
                      onClick: ($event: any) => (_ctx.onDownload(option.value))
                    }, _toDisplayString(option.label), 9, ["onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]),
        default: _withId(() => [
          _createVNode("div", {
            class: "absolute top-5 right-5 cursor-pointer z-10",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, [
            _createVNode("img", {
              src: require('@/app/ui/assets/svg/x-gray.svg'),
              class: "w-6 h-6",
              alt: "close"
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
})